import React, { Fragment } from 'react';
import AbstractComponent from '../../AbstractComponent';

import { loadImage } from '../../../helper/Image';
import { getAppUrlImg } from '../../../helper/Url';

class LogoMarca extends AbstractComponent {     
    constructor(props) {
        super(props);  
        
        this.state = {
            onValidaLogo: false
        }
    }   

    carregarArquivo() {
        loadImage("erro", "logo", "preview");                    
    }    

    upload() {      
        this.setState({onValidaLogo: true});             
        document.getElementById('logo').click();
    }   
    
    preview() {        
        return this.props.form.preview 
            ? '' : 
            'display-none';
    }

    onValidaLogo() {
        if(!this.state.onValidaLogo)
            return ;
            
        this.props.onValidaLogo();
    }

    render() {
        return(                                                                 
            <Fragment>
                <input type="file" name="logo" id="logo" className="hide" onChange={e => this.carregarArquivo(e)}/>
                <input type="hidden" name="erro" id="erro" className="hide"/>
 
                <div className="col-md-3                                 
                                col-sm-3                                                
                                col-lg-3                                                
                                col-xs-3">
                    <div className="col-md-1">
                    </div>

                    <div className="col-md-11" style={{fontSize: '13px'}}>
                        <b>Requisitos Mínimos:</b>

                        <ul> 
                            <li>Tamanho: 512x512</li>
                            <li>Formato: png</li>                                        
                        </ul>

                        <b>Requisitos Desejável:</b>
                        <ul>
                            <li>Fundo: Transparente</li>
                        </ul>
                    </div>
                </div>

                <div className="col-md-9                                 
                                col-sm-9                                                
                                col-lg-9                                                
                                col-xs-9">
                    <div className="col-md-12" style={{textAlign: "center", marginBottom: '20px'}}>

                        { !this.props.form.preview &&
                            <a onClick={e => this.upload(e)}>
                                <i className="fa fa-file-image fa-8x"/>
                            </a>
                        }
                        
                        <a onClick={e => this.upload(e)}>
                            <img 
                                id="preview" 
                                className={"img-preview " + this.preview()}
                                alt="Logomarca"                                     
                                style={{width: '8em'}}
                                src={getAppUrlImg() + 'logo/' + this.props.form.logo}
                                onLoad={() => this.onValidaLogo()}
                            />
                        </a>                        
                    </div>                

                    <div className="row" style={{display: 'contents'}}>
                        <div className="col-md-12 text-center">
                            <span className="help-block text-center">                                        
                                {this.props.erroForm.logo}
                            </span>
                        </div>
                    </div>
                </div>
            </Fragment>            
        )
    }
}

export default LogoMarca;